<template>
    <div class="o-t-transport-select">
        <div class="o-t-transport-select__title">
            {{ title }}
        </div>
        <div class="o-t-transport-select__list">
            <OTTranssportItem
                v-for="item in items"
                :key="item.name"
                :class="{active: item.routeId === activeTransportId}"
                :item="item"
                @changeTransportItem="changeTransportItem(item)"
            />
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import OTTranssportItem from '../o-t-transport-item/o-t-transport-item.vue'

export default {
    name: 'OTTransportSelect',
    components: {
        OTTranssportItem
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        activeTransportId: {
            type: [Number, String],
            default: 0
        },
        activeTransportName: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        params() {
            return this.getMapConfigProp('components.OTTransportSelect.params') || {};
        },
        title() {
            if(this.params.is_show_transport_type) {
                return this.$t('ui.terminal.select-title-type', { type: this.activeTransportName })
            }
            return this.$t('ui.terminal.select-title', 'Velg buss')
        }
    },
    methods: {
        changeTransportItem(item) {
            this.$emit('changeTransportItem', item);
        }
    }
}

</script>

<style lang="scss" src="./theme.scss" />